/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPaymentCollectionDto
 */
export interface GetPaymentCollectionDto {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentCollectionDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentCollectionDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentCollectionDto
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof GetPaymentCollectionDto
     */
    collectionDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentCollectionDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentCollectionDto
     */
    totalAmount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentCollectionDto
     */
    origin?: GetPaymentCollectionDtoOriginEnum | null;
}


/**
 * @export
 */
export const GetPaymentCollectionDtoOriginEnum = {
    PatientPortal: 'PatientPortal',
    BatchPayment: 'BatchPayment',
    SinglePayment: 'SinglePayment',
    Receipt: 'Receipt',
    PaidInvoice: 'PaidInvoice'
} as const;
export type GetPaymentCollectionDtoOriginEnum = typeof GetPaymentCollectionDtoOriginEnum[keyof typeof GetPaymentCollectionDtoOriginEnum];


/**
 * Check if a given object implements the GetPaymentCollectionDto interface.
 */
export function instanceOfGetPaymentCollectionDto(value: object): value is GetPaymentCollectionDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('systemNumber' in value) || value['systemNumber'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function GetPaymentCollectionDtoFromJSON(json: any): GetPaymentCollectionDto {
    return GetPaymentCollectionDtoFromJSONTyped(json, false);
}

export function GetPaymentCollectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPaymentCollectionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'name': json['name'],
        'collectionDate': json['collectionDate'] == null ? undefined : (new Date(json['collectionDate'])),
        'active': json['active'],
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
        'origin': json['origin'] == null ? undefined : json['origin'],
    };
}

export function GetPaymentCollectionDtoToJSON(value?: GetPaymentCollectionDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'systemNumber': value['systemNumber'],
        'name': value['name'],
        'collectionDate': value['collectionDate'] == null ? undefined : ((value['collectionDate'] as any).toISOString()),
        'active': value['active'],
        'totalAmount': value['totalAmount'],
        'origin': value['origin'],
    };
}

